import type { CountryCodeEnum } from '@/enums/country-code-enum';
import { readCountryCode } from '@/store/country-code-store';

// Snapshot não-reativo do país. Para reatividade (re-render quando o país chega), use o
// external store diretamente via `useSyncExternalStore` (ver use-captcha-bypass).
export function getUserCountryCode(): CountryCodeEnum {
  return readCountryCode();
}
